"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PostProductDelete = void 0;
const Base_1 = require("./Base");
exports.PostProductDelete = {
    url: Base_1.URL_BASE + "/ProductDelete",
    method: "POST",
    secure: true
};
//# sourceMappingURL=PostProductDelete.js.map